/**
 * Akty notarialne z RCN → wiersze snapshotu wyceny.
 *
 * Mapowanie żyje tutaj, a nie w komponencie, bo przechodzi przez granicę, której
 * kompilator nie widzi: API oddaje pola po polsku (`adres`, `pow`, `cena`), a snapshot
 * w bazie trzyma angielskie. Trzy kopie tego samego `.map()` (kreator, sekcja oferty,
 * raport) rozjechałyby się przy pierwszej zmianie nazwy pola — i to bez błędu typów.
 */

/** Akt notarialny pokazywany w raporcie wyceny jako dowód „skąd ta cena". */
export interface OfferValuationRow {
  address: string;
  areaM2: number | null;
  price: number | null;
  ppm: number | null;
  /** Rynek: „wtórny" / „pierwotny" — wartość domenowa czytana przez człowieka. */
  market: string;
  /** Data aktu, YYYY-MM-DD. */
  date: string;
}

/**
 * Kształt wiersza z API RCN — opisany strukturalnie, żeby `shared` nie musiał
 * zależeć od typów `apps/web`.
 */
export interface RcnRowLike {
  adres?: string | null;
  msc?: string | null;
  pow?: number | null;
  cena?: number | null;
  ppm?: number | null;
  rynek?: string | null;
  data?: string | null;
}

/**
 * Ile aktów trafia do snapshotu i do tabeli w raporcie. Limit jest jeden, bo
 * snapshot zapisujemy już przycięty — inaczej raport obiecywałby „pokazano 12 z 40",
 * mając w bazie tylko 12.
 */
export const SNAPSHOT_ROWS = 12;

export function toValuationRows(rows: readonly RcnRowLike[]): OfferValuationRow[] {
  return rows.slice(0, SNAPSHOT_ROWS).map((r) => ({
    address: r.adres || r.msc || "",
    areaM2: r.pow ?? null,
    price: r.cena ?? null,
    ppm: r.ppm ?? null,
    market: r.rynek || "",
    date: r.data || "",
  }));
}
